/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

type _Mitteilungsart = "BANNER" | "DIALOG"

type Leer = "";

type Mitteilungsart = _Mitteilungsart | Leer;

export default Mitteilungsart;

export class Mitteilungsarten {
    public static readonly banner: Mitteilungsart = "BANNER";
    public static readonly dialog: Mitteilungsart = "DIALOG";
    public static readonly leer: Mitteilungsart = "";
}
